// import React, { useRef, useState } from "react";
// import './image-upload.scss'
// import pdf_img from "../../../../assets/images/PDF.png"

// const ImageUpload = ({ purpose, title = "Add", multiple = true, limit = 5, storeImage, removeImage, accept = ".png, .jpg, .jpeg, .svg,.pdf" }) => {
//     let inputFileRef = useRef(null)
//     const [images, setImages] = useState([]);
//     const onclickInputFile = () => {
//         inputFileRef?.current?.click();
//     }

//     const onChangeInputFile = (e) => {
//         if (!multiple && inputFileRef?.current?.files[0]?.name) {
//             setImages([{ name: inputFileRef?.current?.files[0]?.name, url: URL.createObjectURL(inputFileRef?.current?.files[0]) }])
//             storeImage(inputFileRef?.current?.files)
//         }
//         else if ((+inputFileRef?.current?.files?.length + +images?.length) <= limit) {
//             let newImages = [...images];
//             for (let i = 0; i < inputFileRef?.current?.files?.length; i++) {
//                 newImages.push({ name: inputFileRef?.current?.files[i]?.name, url: URL.createObjectURL(inputFileRef?.current?.files[i]) })
//             }
//             setImages([...newImages])
//             storeImage(inputFileRef?.current?.files)
//         }
//         else if (multiple) {
//             alert("You can not add more than 5 files/images")
//         }
//     }

//     const onRemoveImage = (index) => {
//         if (!multiple) {
//             setImages([])
//         }
//         else {
//             let newImages = [...images];
//             newImages?.splice(index, 1)
//             setImages([...newImages])
//         }
//         removeImage(index)
//     }

//     const returnTypeFun = (name) => {
//         const type = name?.split(".")
//         return type[type?.length - 1]
//     }

//     return (
//         <div className="d-flex flex-wrap">
//             <div className="upload-design " onClick={onclickInputFile}>
//                 <i className="fas fa-camera fa-2x text-secondary" />
//                 <p className="font-weight-bold"> {title}</p>
//             </div>
//             {!!images && images?.length > 0 && images?.map((imageList, imageListIndex) => {
//                 returnTypeFun(imageList?.name)
//                 return (
//                     <div className="preview-image mb-2" key={'showExpenseImage' + imageListIndex}>
//                         <div className="remove-image" onClick={() => onRemoveImage(imageListIndex)}>
//                             X
//                         </div>
//                         {returnTypeFun(imageList?.name) === "pdf" ? <img className="preview-image-item" src={pdf_img} alt="" /> : <img className="preview-image-item" src={imageList?.url} alt="" />}
//                     </div>
//                 )
//             })}
//             <input multiple={multiple} type="file" ref={inputFileRef} onChange={(e) => { onChangeInputFile(e.target.files) }} className="d-none" accept={accept} />
//         </div>)
// }

// export default ImageUpload


import React, { useRef, useState } from "react";
import './image-upload.scss'
import pdf_img from "../../../../assets/images/PDF.png"
import imageCompression from 'browser-image-compression';

const IMAGE_EXTENSIONS = /\.(jpe?g|png|gif|webp|heic|heif|bmp)$/i;

const ImageUpload = ({ purpose, title = "Add", multiple = true, limit = 5, storeImage, removeImage, accept = "image/*, .pdf" }) => {
    let inputFileRef = useRef(null);
    const [images, setImages] = useState([]);

    const onclickInputFile = () => {
        inputFileRef?.current?.click();
    };

    const compressImage = async (file) => {
        const options = {
            maxSizeMB: 0.5,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
        };
        try {
            const compressedFile = await imageCompression(file, options);
            return compressedFile;
        } catch (error) {
            console.error("Compression failed:", error);
            return file;
        }
    };

    const onChangeInputFile = async (e) => {
        const files = Array.from(e);
        if (!multiple && files[0]?.name) {
            const compressed = await compressImage(files[0]);
            const url = URL.createObjectURL(compressed);
            setImages([{ name: compressed.name, url }]);
            storeImage([compressed]); // pass as FileList/Array
        } else if ((+files.length + +images.length) <= limit) {
            let newImages = [...images];
            let compressedFiles = [];

            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                // iOS camera can return type:"" or "image/heic" — treat as image when type is
                // absent but the name looks like an image, or when type explicitly starts with image/
                const looksLikeImage = file.type.startsWith("image/") ||
                    (file.type === "" && IMAGE_EXTENSIONS.test(file.name));
                if (looksLikeImage) {
                    const compressed = await compressImage(file);
                    compressedFiles.push(compressed);
                    newImages.push({ name: compressed.name, url: URL.createObjectURL(compressed) });
                } else {
                    compressedFiles.push(file);
                    newImages.push({ name: file.name, url: URL.createObjectURL(file) });
                }
            }

            setImages([...newImages]);
            storeImage(compressedFiles); // send compressed files
        } else if (multiple) {
            alert("You can not add more than 5 files/images");
        }
    };

    const onRemoveImage = (index) => {
        if (!multiple) {
            setImages([]);
        } else {
            let newImages = [...images];
            newImages.splice(index, 1);
            setImages([...newImages]);
        }
        removeImage(index);
    };

    const returnTypeFun = (name) => {
        const type = name?.split(".");
        return type[type?.length - 1];
    };

    return (
        <div className="d-flex flex-wrap">
            <div className="upload-design " onClick={onclickInputFile}>
                <i className="fas fa-camera fa-2x text-secondary" />
                <p className="font-weight-bold"> {title}</p>
            </div>
            {!!images?.length && images.map((imageList, imageListIndex) => (
                <div className="preview-image mb-2" key={'showExpenseImage' + imageListIndex}>
                    <div className="remove-image" onClick={() => onRemoveImage(imageListIndex)}>X</div>
                    {returnTypeFun(imageList?.name) === "pdf" ?
                        <img className="preview-image-item" src={pdf_img} alt="" />
                        :
                        <img className="preview-image-item" src={imageList?.url} alt="" />}
                </div>
            ))}
            <input multiple={multiple} type="file" ref={inputFileRef} onChange={(e) => onChangeInputFile(e.target.files)} className="d-none" accept={accept} />
        </div>
    );
};

export default ImageUpload;
